
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp-designsystem-contact-completed",
      function () {
        return require("private-next-pages/lp-designsystem-contact-completed.tsx");
      }
    ]);
  